module.exports = __webpack_public_path__ + "static/media/play-boss-2.ff3512c8.png";